export const STATUS_PENDING = 'PENDING';
export const STATUS_SUCCESS = 'SUCCESS';
export const STATUS_FAILURE = 'FAILURE';
